<template>
  <aside class="sidebar" id="sidebar">
    <div class="sidebar-header">
      <button @click="toggleSidebar" id="toggleSidebarBtn" class="sidebar-toggle-btn icon-btn">
        <span class="material-symbols-rounded menu-icon">menu</span>
        <span class="material-symbols-rounded close-icon hidden">close</span>
      </button>
    </div>

    <div class="sidebar-section">
      <button @click="newChat" class="btn btn-change-chatbot">
        <span class="material-symbols-rounded">add</span>
        <span class="btn-text">New Conversation</span>
      </button>

      <button onclick="toggleChatbotDropdown()" class="btn btn-change-chatbot" style="display: none;">
        <span class="material-symbols-rounded">robot</span>
        <span class="btn-text">Change Chatbot</span>
      </button>

      <div id="chatbotDropdown" class="chatbot-dropdown-container" style="display: none;">
        <button class="btn chatbot-dropdown-item active" data-value="general">
          <span class="material-symbols-rounded">psychology</span>
          <span class="btn-text">General Chatbot</span>
        </button>

        <button class="btn chatbot-dropdown-item" data-value="study">
          <span class="material-symbols-rounded">school</span>
          <span class="btn-text">Study Assistant</span>
        </button>

        <button class="btn chatbot-dropdown-item" data-value="travel">
          <span class="material-symbols-rounded">travel_explore</span>
          <span class="btn-text">Travel Planner</span>
        </button>

        <button class="btn chatbot-dropdown-item" data-value="business">
          <span class="material-symbols-rounded">business_center</span>
          <span class="btn-text">Business Writer</span>
        </button>

        <button class="btn chatbot-dropdown-item" data-value="legal">
          <span class="material-symbols-rounded">balance</span>
          <span class="btn-text">Legal Assistant</span>
        </button>

        <button class="btn chatbot-dropdown-item" data-value="social">
          <span class="material-symbols-rounded">share</span>
          <span class="btn-text">Social Media Helper</span>
        </button>
      </div>

      <button @click="conversationHistoryVisible = !conversationHistoryVisible" class="btn btn-change-chatbot" id="conversationHistoryToggle">
        <span class="material-symbols-rounded">history</span>
        <span class="btn-text">Conversation History</span>
      </button>

      <div v-if="conversationHistoryVisible" id="conversationHistoryDropdown">
        <div v-if="conversationHistoryLoading" class="flex items-center justify-center py-4">
          <p>Loading...</p>
        </div>

        <ul v-else-if="conversationHistory.length > 0">
          <li v-for="conversation in conversationHistory" :key="conversation.id">
            <router-link :to="{ name: 'Conversation', params: { uuid: conversation.id } }" class="chat-history-item">
              <span class="material-symbols-rounded">chat</span>
              <span class="chat-history-text">{{ conversation.name }}</span>
            </router-link>
          </li>
        </ul>

        <div v-else class="no-chat-history">
          <ul>
            <li>No chat history available.</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="sidebar-bottom-actions">
      <button v-if="!isPremium" id="upgradeToProSidebarBtn" @click="upgradePlan" class="btn btn-sidebar">

        <span class="material-symbols-rounded">workspace_premium</span>
        <span class="btn-text">Upgrade to Pro</span>
      </button>

      <button id="manageSubscriptionSidebarBtn" onclick="cancelPlan()" class="btn btn-sidebar hidden">
        <span class="material-symbols-rounded">payments</span>
        <span class="btn-text">Manage Subscription</span>
      </button>

      <button onclick="showSettingsScreen()" class="btn btn-sidebar">
        <span class="material-symbols-rounded">settings</span>
        <span class="btn-text">Settings</span>
      </button>

      <button v-if="authStore.user" @click="handleLogout" class="btn btn-sidebar btn-logout">
        <span class="material-symbols-rounded">logout</span>
        <span class="btn-text">Logout</span>
      </button>
    </div>
  </aside>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useConversationStore } from "@/stores/conversation.js";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import router from '@/router';
import { toggleSidebar } from '@/utils';
import { auth } from "@/firebase.js";

const conversationHistoryVisible = ref(false);
const conversationHistory = ref([]);
const conversationHistoryLoading = ref(false);

const isPremium = ref(false);
const authStore = useAuthStore();

const u = async () => {
  const user = getAuth();
  const token = user.currentUser ? await user.currentUser.getIdToken() : null;
  alert(token);
};

watch(conversationHistoryVisible, (newVal, oldVal) => {
  // console.log("Chat history dropdown is now:", newVal ? "Visible" : "Hidden");
  if (newVal) {
    getConversationHistory();
  }
});

// u();
const getConversationHistory = async () => {
  try {
    conversationHistoryLoading.value = true;
    const data = await useConversationStore().getConversationHistory();
    if (!data) {
      alert('No chat history found.');
      return;
    }
    conversationHistory.value = data || [];
    conversationHistoryVisible.value = true;
  } catch (error) {
    console.error('Error fetching chat history:', error);
    alert('Failed to fetch chat history. Please try again later.');
  }
  finally {
    conversationHistoryLoading.value = false;
  }
};

const handleLogout = async () => {
  await authStore.logout();
  router.push('/?logout=true');
};

const newChat = async () => {
  await useConversationStore().initNewChat('general');
  const conversationId = await useConversationStore().getChatId();
  if(!conversationId) {
    alert('Failed to create a new chat. Please try again.');
    return;
  }
  router.push({ name: 'Conversation', params: { uuid: conversationId } });
};

const upgradePlan = async () => {

  router.push({ name: 'UpgradeBenefits' });
};

</script>
